const fcl = require('@onflow/fcl');
import { IS_PROD } from 'util/constants';

fcl.config({
  'app.detail.title': 'Ozone Market',
  'app.detail.icon':
    'https://ozone-marketplace-assets.s3.amazonaws.com/logo.jpeg',
  'accessNode.api': IS_PROD
    ? 'https://rest-mainnet.onflow.org'
    : 'https://rest-testnet.onflow.org',
  'discovery.wallet': IS_PROD
    ? 'https://fcl-discovery.onflow.org/mainnet/authn'
    : 'https://fcl-discovery.onflow.org/testnet/authn',
  'discovery.authn.endpoint': IS_PROD
    ? 'https://fcl-discovery.onflow.org/api/authn'
    : 'https://fcl-discovery.onflow.org/api/testnet/authn',
  'fcl.limit': 1000,
  'discovery.authn.include': [
    `${IS_PROD ? '0xead892083b3e2c6c' : '0x82ec283f88a62e65'}`,
  ],
});
